import { render, staticRenderFns } from "./link-stats.vue?vue&type=template&id=2e4c78f4&scoped=true&"
import script from "./link-stats.vue?vue&type=script&lang=js&"
export * from "./link-stats.vue?vue&type=script&lang=js&"
import style0 from "./link-stats.vue?vue&type=style&index=0&id=2e4c78f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c78f4",
  null
  
)

export default component.exports